/* countdown-timer.js
 * Visar:
 *  - ENDAST dagar när det återstår ≥ 1 dag.
 *  - Timmar + minuter när dagar = 0.
 * Minuter visas alltså bara när inga hela dagar återstår.
 * När countdownen är slut (<= 0 sekunder) göms hela timern.
 */

(function () {
  'use strict';

  // Kör när DOM är redo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    var timers = document.querySelectorAll('.countdown-timer');
    if (!timers.length) return;

    timers.forEach(function (el) {
      // Rensa ev. tidigare intervall
      if (el.__ctInterval) {
        clearInterval(el.__ctInterval);
        el.__ctInterval = null;
      }

      var start = parseInt(el.dataset.start, 10) || 0;
      var end   = parseInt(el.dataset.end, 10)   || 0;
      if (!end) return;

      // Första render
      tick(el, start, end);

      // Uppdatera var 30:e sekund
      el.__ctInterval = setInterval(function () {
        tick(el, start, end);
      }, 30000);
    });
  }

  function tick(el, start, end) {
    try {
      var now = Math.floor(Date.now() / 1000);
      var diff = end - now;

      // Om tiden är ute: stoppa intervallet och göm timern
      if (diff <= 0) {
        if (el.__ctInterval) {
          clearInterval(el.__ctInterval);
          el.__ctInterval = null;
        }
        el.style.display = 'none';
        return;
      }

      render(el, diff);
    } catch (err) {
      console.error('countdown-timer error:', err);
    }
  }

  function render(el, diffSeconds) {
    var daySing = el.dataset.labelDaySingular     || 'day';
    var dayPlu  = el.dataset.labelDayPlural       || 'days';
    var hrSing  = el.dataset.labelHourSingular    || 'hour';
    var hrPlu   = el.dataset.labelHourPlural      || 'hours';
    var minSing = el.dataset.labelMinuteSingular  || 'minute';
    var minPlu  = el.dataset.labelMinutePlural    || 'minutes';

    var days    = Math.floor(diffSeconds / 86400);
    var rem     = diffSeconds % 86400;
    var hours   = Math.floor(rem / 3600);
    rem         = rem % 3600;
    var minutes = Math.floor(rem / 60);

    var valueEl = el.querySelector('.timer-value');
    if (!valueEl) return;

    var text;

    if (days > 0) {
      // ≥ 1 dag kvar: visa bara dagar
      text = days + ' ' + pluralize(days, daySing, dayPlu) + '.';
      el.setAttribute('data-days-zero', 'false');
    } else {
      // 0 dagar kvar: visa timmar + minuter
      text =
        hours + ' ' + pluralize(hours, hrSing, hrPlu) + ', ' +
        minutes + ' ' + pluralize(minutes, minSing, minPlu) + '.';
      el.setAttribute('data-days-zero', 'true');
    }

    valueEl.textContent = text;
  }

  function pluralize(n, singular, plural) {
    return n === 1 ? singular : plural;
  }
})();